/**
 * @file Enrollment Result Card Iframe
 */

/**
 * Enrollment Result Card Iframe component
 */
const vEnrollmentResultCardIframe = () => {
	if ( document.getElementById( 'v-enrollment-result-card__commercial-iframe' ) ) {
		const tag = document.createElement( 'script' );
		tag.src = 'https://www.youtube.com/iframe_api';
		const firstScriptTag = document.getElementsByTagName( 'script' )[0];
		firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );

		window.onYouTubeIframeAPIReady = function() {
			window.player = new YT.Player( 'v-enrollment-result-card__commercial-iframe', {
				width: '100%',
				height: '315',
				videoId: 'kilS8poTadw',
				playerVars: {
					'controls': 0,
					'rel': 0,
					'showinfo': 0,
				},
				events: {
					onReady: onPlayerReady,
				},
			} );
		};

		/**
		 * Set Event Listeners for controls
		 */
		function onPlayerReady() {
			const playBtn = document.getElementById( 'v-enrollment-play-btn' );
			const pauseBtn = document.getElementById( 'v-enrollment-pause-btn' );
			const stopBtn = document.getElementById( 'v-enrollment-stop-btn' );
			const scrubBtn = document.getElementById( 'v-enrollment-result-card-scrub' );
			playBtn.addEventListener( 'click', () => window.player.playVideo() );
			pauseBtn.addEventListener( 'click', () => window.player.pauseVideo() );
			stopBtn.addEventListener( 'click', () => window.player.stopVideo() );

			scrubBtn.addEventListener( 'change', ( e ) => {
				const seek = Math.round( window.player.getDuration() * ( e.target.value / 100 ) );
				window.player.seekTo( seek );

				if ( e.target.value == 100 ) {
					clearInterval( updateProgress );
				}
				// console.log( 'Seeked to: ' + seek + ' seconds or ' + e.target.value + '%' );
			} );

			const updateProgress = setInterval( () => {
				const progress = Math.round( window.player.getCurrentTime() / window.player.getDuration() * 100 );
				document.getElementById( 'v-enrollment-result-card-scrub' ).value = progress;
				// console.log( 'Progress updated to: ' + progress + '%' );
			}, 5000 );
		}
	}
}

export default vEnrollmentResultCardIframe;
